(function () {
  var fileInput  = document.getElementById('logo-upload');
  var urlInput   = document.getElementById('logo-upload-url');
  var filenameEl = document.getElementById('upload-filename');
  var statusEl   = document.getElementById('upload-status');
  var atcButton  = document.getElementById('add-to-cart');
  var emailInput = document.getElementById('proof-email');
  var qtyInput   = document.getElementById('quantity');
  var form       = document.getElementById('product-form');

  if (!fileInput || !urlInput) return;

  var UPLOADCARE_KEY = '9a52086c000b73cf7828';
  var CDN_BASE = 'https://2iiwvc9aw6.ucarecd.net/';

  var selectedFile  = null;
  var attachedState = '';
  var reuploading   = false;
  var changeTimer   = null;

  var SKIP = ['Logo File', 'Proof Email'];

  function currentEmail() {
    if (!emailInput) return '';
    var v = emailInput.value.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? v : '';
  }

  function currentQty() {
    if (!qtyInput) return '';
    var v = parseInt(qtyInput.value, 10);
    return (v > 0) ? String(v) : '';
  }

  function collectSelections() {
    var out = {};
    if (!form) return out;
    var fields = form.querySelectorAll('[name^="options["], [name^="properties["]');
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      if (el === fileInput || el === urlInput || el.type === 'file') continue;
      var name = el.getAttribute('name') || '';
      var m = name.match(/\[(.+?)\]/);
      if (!m) continue;
      var label = m[1];
      if (SKIP.indexOf(label) !== -1) continue;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) continue;
      var val = (el.value || '').trim();
      if (!val) continue;
      var key = label.toLowerCase().replace(/[^a-z0-9]+/g, '_')
                     .replace(/^_+|_+$/g, '').slice(0, 64);
      if (!key) continue;
      out[key] = val.slice(0, 512);
    }
    return out;
  }

  // Metadata must NEVER break an upload — any failure here returns
  // a minimal object and the upload proceeds regardless.
  function buildMetadata() {
    var meta = {};
    try {
      meta = collectSelections();
      var email = currentEmail();
      var qty = currentQty();
      if (email) meta.email = email;
      if (qty) meta.quantity = qty;
      meta.product = (document.title || '').slice(0, 512);
    } catch (err) {
      console.error('Metadata collection failed (upload continues):', err);
    }
    return meta;
  }

  function doUpload(file, meta) {
    var formData = new FormData();
    formData.append('UPLOADCARE_PUB_KEY', UPLOADCARE_KEY);
    formData.append('UPLOADCARE_STORE', '1');
    try {
      var count = 0;
      for (var key in meta) {
        if (!meta.hasOwnProperty(key)) continue;
        if (++count > 40) break;
        formData.append('metadata[' + key + ']', meta[key]);
      }
    } catch (err) {
      console.error('Metadata append failed (upload continues):', err);
    }
    formData.append('file', file);

    return fetch('https://upload.uploadcare.com/base/', {
      method: 'POST',
      body: formData
    })
    .then(function (response) { return response.json(); })
    .then(function (data) {
      if (!data.file) throw new Error('Upload rejected: ' + JSON.stringify(data));
      return CDN_BASE + data.file + '/';
    });
  }

  // Try with metadata; if Uploadcare rejects it, retry once bare.
  function uploadWithFallback(file, meta) {
    return doUpload(file, meta).catch(function (err) {
      console.error('Upload with metadata failed, retrying without:', err);
      return doUpload(file, {});
    });
  }

  // ---- Primary upload: fires immediately on file selection ----
  fileInput.addEventListener('change', function () {
    var file = fileInput.files[0];
    if (!file) return;

    selectedFile = file;
    setStatus('Uploading...', '#c9a84c');
    if (atcButton) atcButton.disabled = true;
    if (filenameEl) filenameEl.textContent = file.name;

    var meta = buildMetadata();

    uploadWithFallback(file, meta)
      .then(function (url) {
        urlInput.value = url;
        attachedState = JSON.stringify(meta);
        setStatus('✓ File ready', '#5a9e6f');
      })
      .catch(function (error) {
        console.error('Upload error:', error);
        setStatus('Upload failed — please try again', '#c0392b');
        urlInput.value = '';
      })
      .then(function () {
        if (atcButton) atcButton.disabled = false;
      });
  });

  // ---- Silent re-attach on any form change (debounced 3s) ----
  if (form) {
    var debouncedReattach = function (e) {
      if (e && e.target === fileInput) return;
      clearTimeout(changeTimer);
      changeTimer = setTimeout(maybeReattach, 3000);
    };
    form.addEventListener('change', debouncedReattach);
    form.addEventListener('input', debouncedReattach);
  }

  function maybeReattach() {
    if (!selectedFile || !urlInput.value || reuploading) return;

    var meta = buildMetadata();
    var state = JSON.stringify(meta);
    if (state === attachedState) return;

    reuploading = true;
    doUpload(selectedFile, meta)
      .then(function (url) {
        urlInput.value = url;
        attachedState = state;
      })
      .catch(function (error) {
        console.error('Re-attach failed (non-blocking):', error);
      })
      .then(function () {
        reuploading = false;
      });
  }

  // ---- Submit guard: only blocks while primary upload is in flight ----
  if (form) {
    form.addEventListener('submit', function (e) {
      if (fileInput.files.length > 0 && !urlInput.value) {
        e.preventDefault();
        setStatus('Please wait — still uploading...', '#c9a84c');
      }
    });
  }

  function setStatus(msg, color) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.style.color = color;
    statusEl.style.display = 'block';
  }
})();